
<p8-layout-settings-header [titlePath]="['Téléversement des scans']"
                           [iconRacine]="'document_scanner'"
                           [card]="true">
  <div after-card><small class="help-text-h2">Vous pouvez Sélectionner plusieurs fichiers a la fois</small></div>
</p8-layout-settings-header>

<mat-dialog-content class="mat-typography">
  <div class="upload-container" style="padding-top: 10px">
    <button mat-raised-button color="primary" (click)="fileInput.click()"
            [matTooltip]="'Vous pouvez Sélectionner plusieurs fichiers'">
      <mat-icon>attach_file</mat-icon>
      Sélectionner des fichiers
    </button>
    <p class="help-text">(*) Les fichiers acceptés sont au format PNG, JPG, JPEG et PDF.</p>
    <!-- champ file masqué, multiple -->
    <input
      #fileInput
      type="file"
      [accept]="requiredFileTypes"
      multiple
      [hidden]="true"
      (change)="onFileSelected($event)"
    />
    <div *ngIf="uploadProgress">
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </div>
    <!-- Liste des fichiers sélectionnés -->
    <ul>
      <li *ngFor="let s of scans; let i = index" style="color: green;font-size: small;">
        {{ s.file_name }}
        <button mat-icon-button color="warn"
                (click)="removeFile(i)"
                [disabled]="uploadProgress">
          <mat-icon>delete</mat-icon>
        </button>
      </li>
    </ul>
    <ul>
      <li *ngFor="let s of scansFromDb; let i = index" style="font-size: small;" class="file-name">
        {{ s.file_name }}
        <button mat-icon-button (click)="downloadSingleScan(s)">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="removeFile(i, s.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </li>
    </ul>

  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="onCloseClick()">Fermer</button>
  <button  mat-raised-button color="primary" (click)="uploadFiles()"
           [disabled]="scans.length <= 0 || uploadProgress">Téléverser</button>
</mat-dialog-actions>
